const endpoint = "https://mobb.cuba-games.com"
const cpoint = "https://central-backend.cuba-lv.com"
const mediapoint = `${cpoint}`
const startpoint = `${cpoint}/`

const internetSpeedImgLink = ""
const gamePlace = { studio: "tbilisi", room: "po6-room" } //bishkek, tbilisi

export { endpoint, mediapoint, startpoint, internetSpeedImgLink, gamePlace }
